import { useDropzone } from "react-dropzone";
import { Label, ToolTipV1, Note } from "lib";
import { useState, useEffect, useCallback } from "react";
import ProgressBar from "./components/documentprogress";
import "./index.scss";
import ImageUpload from "../../assets/images/image_upload.svg";
import Image from "../Image";
import { useDispatch } from "react-redux";
import { uploadUserDocument, removeUserDocument, previewUploadedDocument } from "api/formDisplay";
import ErrorMessage from "lib/ErrorMessage";
import Digilocker from "./components/digilocker"
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Capture from "./components/capture";
import {
  deleteUploadedDocument,
  setDocuments,
  setFaceObject,
  setFetchedDocument,
  setUploadedDocument,
  setdeleteDocument
} from "redux/uploadDocumentReducer";
import Toast from "components/ToastComponent";
import { setConfigLoading, setConfigLoadingText, setUploadLoading } from "redux/configurationReducer";
import { setMandatoryExtraction,clearSelectedDataKey } from "redux/formDisplay";
import Modal from "lib/DocumentViewer/Modal";
import LoadingSpinner from "lib/LoadingSpinner";
import { BASE_URL } from "constants/routes";
import { setdeleteRecursiveDocument } from "redux/recursiveReducer";
import { Row } from "react-bootstrap";
import { PDFDocument } from 'pdf-lib';



const Upload = (props) => {
  let {
    label,
    enum: enums,
    tooltip,
    tooltipText,
    name,
    error,
    formErr,
    setFormErr,
    clearFieldError,
    selectedData,
    size,
    setSelectedData,
    isEditable,
    // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
    verify,
    autofill, is_disabled,
    doc_type,
    service_type,
    extraction_required,
    validators,
    maxSize,isDisabLed,
    masking_required,
    isUserInitiated,
    isRecursive,
    doc_number_validation,
    digilocker,
    capture,
    face_match_document,
    mrz_validity,
    value:uploadedFileData,
    error_messages,
    conversion_required,
    conversion_filename,
    eval_required
  } = props;

  const [uploaded, setUploaded] = useState(false);
  const [fileName, setFileName] = useState();
  const [fileSize, setFileSize] = useState();
  const [invalidError, setInvalidError] = useState("");
  const [messageToast, setMessageToast] = useState({type:"",msg:""});
  const [isUploading, setIsUploading] = useState(false);
  const [orcMessage,setOcrMessage] = useState("")
  const [showModal, setShowModal] = useState(false);
  const [resp,setResp] = useState();
  const [loading,setLoading] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [isOtherFile , setIsOtherFile] = useState(false);
  const [isSpreadSheet , setIsSpreadSheet] = useState(false);


  const isAutofilled = useSelector(
    (state) => state.uploadDocumentReducer?.isAutofilled
  );
  const recursive = useSelector((state)=> state?.recursive)
  const documents = useSelector(
    (state) => state.uploadDocumentReducer?.documents
  );
  const uploadedDocuments = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const isToggled = useSelector(state => state.formData.isToggled);
  const copiedData = useSelector(state => state.formData.copiedData);
  
  
  const organisationId = useSelector(state => state.configurationReducer.config?.organisation_id);
  const dispatch = useDispatch();
  const params = useParams();
  const decryptedId = useSelector((state) => state.urlEncryption?.urlId)
  const subWfId = useSelector((state) => state.dashboardDetailReducer?.currentSubWorkFlowId)
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
 
  const customerInfo = useSelector((state) => state.userInfo);
  const verificationResponses = useSelector((state) => state.uploadDocumentReducer);
  const subworkflows = useSelector(
    (state) => state.userInfo.workflowUser.subworkflows
  );
  let dob = subworkflows?.birth_date;
  dob = dob?.split("/").reverse().join("-");
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const userInfo = {
    userId: decryptedId.userId,
    primaryWorkflowId: decryptedId.primaryWorkflowId,
    subWfId: decryptedId.subWfId,
    organisationId
  };
  const docType =  eval_required ? eval(doc_type)  : doc_type?.toLowerCase() || "document";
  verify = eval_required ? eval(verify) : verify
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const maxSizeInMb = Math.ceil(maxSize / (1024 * 1024)); 
  const handleOnDropAccepted = async (acceptedFiles, rejectedFiles) => {
    try {
      const promises = acceptedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          if (file?.type === "application/pdf" && validators?.orientation_allowed === "portrait") {
            const fileReader = new FileReader();
            fileReader.onloadend = async () => {
              try {
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await PDFDocument.load(arrayBuffer);
                const pageCount = pdf.getPageCount();
  
                let isValidSize = true;
  
                for (let i = 0; i < pageCount; i++) {
                  const page = pdf.getPage(i);
                  const { width, height } = page.getSize();
  
                  if (!(width >= 580 && width <= 615 && height >= 790 && height <= 899)) {
                    console.log(`Invalid page ${i + 1}: width=${width}, height=${height}`);
                    isValidSize = false;
                    break;
                  }
                }
  
                if (isValidSize) {
                  const fileData = {
                    file: file,
                    file_path: file.path || file.file_path,
                    file_size: file.size || file.file_size,
                  };
                  resolve(fileData);
                } else {
                  setMessageToast({ type: "error", msg: error_messages?.orientation_error });
                  setTimeout(() => {
                    setMessageToast(null);
                  }, 2000);
                }
              } catch (err) {
                console.error("Error reading PDF file:", err);
                reject(err);
              }
            };
            fileReader.readAsArrayBuffer(file);
          } else {
            // For non-PDFs or PDFs not needing orientation validation
            const fileData = {
              file: file,
              file_path: file.path,
              file_size: file.size,
            };
            resolve(fileData);
          }
        });
      });
      const acceptedFilesData = await Promise.all(promises);
  
      if (acceptedFilesData.length > 0) {
        clearFieldError && clearFieldError(name);
        setIsUploading(true);
        if (extraction_required || verify) {
          dispatch(setUploadLoading(true))
          if (verify) {
            dispatch(setConfigLoadingText('Document validation is in process..'))
            setOcrMessage("Document validation is in process..")
          } else {
            dispatch(setConfigLoadingText('Data extraction is in process..'))
            setOcrMessage("Data extraction is in process..")
          }
        }
  
        dispatch(
          uploadUserDocument({
            acceptedFile: acceptedFilesData,
            name,
            userInfo,
            label,
            setSelectedData,
            verify,
            autofill,
            extraction_required,
            formErr,
            setFormErr,
            clearFieldError,
            docType,
            service_type,
            masking_required,
            selectedData,
            isRecursive,
            doc_number_validation,
            dob,
            face_match_document,
            mrz_validity,
            conversion_required,
            conversion_filename,        
          })
        ).unwrap().then(
          res => {
            setIsUploading(false);
            dispatch(setUploadLoading(false))
            if (res?.status === "success") {
              setOcrMessage(null)
              setUploaded(true);
              if (extraction_required || verify || res?.data?.responseData?.verification_response) {
                dispatch(setConfigLoading(false))
                setOcrMessage(null)
                if (res?.data?.responseData?.verification_response?.error_code == "dv-001") {
                  setMessageToast({ type: "error", msg: res?.data?.responseData?.verification_response?.message });
                } else {
                  if (res?.message) {
                    setMessageToast({ type: "success", msg: res?.message });
                  } else {
                    setMessageToast({ type: "success", msg: "File content extracted successfully" });
                  }
                }
                setTimeout(() => {
                  setMessageToast(null);
                }, 2000);
              }
            } else {
              setUploaded(false);
              dispatch(setUploadLoading(false))
              setOcrMessage(null)
              if (res?.message) {
                setMessageToast({ type: "error", msg: res?.message });
              } else {
                setMessageToast({ type: "error", msg: "Invalid file, Please upload a valid File" });
              }
              setTimeout(() => {
                setMessageToast(null);
              }, 2000);
            }
          }
        ).catch(err => {
          setIsUploading(false);
          dispatch(setUploadLoading(false))
  
          setOcrMessage(null)
          setMessageToast({ type: "error", msg: "Failed to upload file" });
          setTimeout(() => {
            setMessageToast(null);
          }, 3000);
        });
      }
    } catch (error) {
      console.error('Error processing files:', error);
    }
  }
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: enums,
    maxSize: maxSize,
    onDropAccepted: handleOnDropAccepted,
    onDropRejected: (rejectedFiles) => {
      setUploaded(false);
      dispatch(setUploadLoading(false))
      setOcrMessage(null)
      setMessageToast({type: "error",msg: rejectedFiles[0].errors[0].message});
      setTimeout(() => {
        setMessageToast(null);
      }, 3000);
    },
  });
 

  const acceptedFile = acceptedFiles.map((file) => {
    let fileData = {
      file: file,
      file_path: file.path,
      file_size: file.size,
    };
    return fileData;
  });


  const removeDocument = (name, documents) => {
    let newDoc = { ...documents };
    let newUploadedDocument = { ...uploadedDocuments };
    Object.keys(newDoc).forEach((key) => {
      if (name == key) delete newDoc[key];
    });
    if(isRecursive){
      if (Object.keys(uploadedDocuments).length) {
        Object.keys(newUploadedDocument).forEach((key) => {
          if (recursive?.recursiveFormData[name]?.encrypted_filename == key) delete newUploadedDocument[key];
        });
        dispatch(setUploadedDocument(newUploadedDocument));
      }
    }else{
      if (Object.keys(uploadedDocuments).length) {
        Object.keys(newUploadedDocument).forEach((key) => {
          if (name == key) delete newUploadedDocument[key];
        });
        dispatch(setUploadedDocument(newUploadedDocument));
      }

    }
    dispatch(setFetchedDocument(newDoc));
  };

  const removeFiles = () => {
   
    if(isRecursive){
      dispatch(setdeleteRecursiveDocument({key: name, value: selectedData[name]}))
    }else{
      dispatch(setdeleteDocument({key: name, value: selectedData[name]}))
    }
    dispatch(clearSelectedDataKey({ key: name }))
    dispatch(setSelectedData({key: name, value: null}))
    removeDocument(name, documents);
    acceptedFiles.length = 0;
    acceptedFiles.splice(0, acceptedFiles.length);
    setFileName(null);
    setFileSize(null);
    setUploaded(false);
    setInvalidError(false);
  };

  const cancelClick = () => {
    removeFiles();
  };

  useEffect(() => {
    const uploadedFile = acceptedFile?.[0];
    if (uploadedFile) {
      const { file_path, file_size } = uploadedFile;
      setFileName(file_path);
      setFileSize(file_size);
    }
  }, [acceptedFile]);

  useEffect(() => {
    if (Object.keys(selectedData).includes(name)) {
      setUploaded(true);
    }
    if (autofill) {
      dispatch(setMandatoryExtraction({key: name, value: extraction_required}))
    }
  }, []);
 

  useEffect(() => {
    if(isToggled && copiedData?.[name] !== undefined){
      dispatch(setDocuments({key: name, value: copiedData?.[name]}))  
      dispatch(deleteUploadedDocument({key: name}))
    }
    if (isAutofilled) {
      if (Object.keys(selectedData).includes(name)) {
        setUploaded(true);
      }
    }
  }, [selectedData]);
let enumArray = [];
useEffect(() => {
  if (enumArray?.includes("msword")) {
    setIsOtherFile(true);
  }
}, [enumArray]);

  const getEnum = () => {
    if (Array.isArray(enums)) {
      enumArray = enums;
    } else {
      enumArray = enums && Object.keys(enums)?.map((key) => {
        return key.split("/")[1];
      });
    }
    return enumArray;
  };

  const previewImage = async() => {
    setLoading(true)
    let imageSrc,data
    if(isRecursive){
      data = {
        extension: recursive?.recursiveFormData[`${name}`]?.document_type,
        document_type: name,
        uploaded_at: recursive?.recursiveFormData[`${name}`]?.uploaded_at,
        original_name: recursive?.recursiveFormData[`${name}`]?.original_name || uploadedFileData?.original_name,
        file_size: recursive?.recursiveFormData[`${name}`]?.file_size,
        encrypted_filename: recursive?.recursiveFormData[`${name}`]?.encrypted_filename || uploadedFileData?.encrypted_filename,
        field_label: recursive?.recursiveFormData[`${name}`]?.field_label,
        original_filename: recursive?.recursiveFormData[`${name}`]?.original_filename,
        organisation_id: organisationId,
        _id: decryptedId?.subWfId ? decryptedId?.subWfId : decryptedId?.userId ? decryptedId?.userId : subWfId
      }
      imageSrc = `${BASE_URL}/workflow/viewRecursiveUploadedDocument/${data._id}/${data.document_type}/${data.encrypted_filename}/${data.original_name}/${data.organisation_id}`;
    }else{
     data = {
      extension: documents[`${name}`]?.document_type || uploadedFileData?.document_type,
      document_type: name,
      uploaded_at: documents[`${name}`]?.uploaded_at,
      original_name: documents[`${name}`]?.original_name || uploadedFileData?.original_name,
      file_size: documents[`${name}`]?.file_size,
      encrypted_filename: documents[`${name}`]?.encrypted_filename || uploadedFileData?.encrypted_filename,
      field_label: documents[`${name}`]?.field_label,
      original_filename: documents[`${name}`]?.original_filename,
      organisation_id: organisationId,
      _id: decryptedId?.subWfId ? decryptedId?.subWfId : decryptedId?.userId ? decryptedId?.userId : subWfId
    }
     imageSrc = `${BASE_URL}/workflow/previewUploadedDocument/${data.organisation_id}/${data._id}/${data.document_type}/${data.encrypted_filename}/${data.original_name}`;
   }
    setIsPdf(data.extension === ".pdf" || data.extension === ".PDF")
    const imageFile = [".jpg", ".jpeg", ".png",".csv",".xlsx",".JPG", ".JPEG", ".PNG",".CSV",".XLSX"];
    const spreadSheet = [".csv",".xlsx",".CSV",".XLSX"]
    setIsSpreadSheet(spreadSheet.includes(data.extension))
    setIsOtherFile(!imageFile.includes(data.extension))
    if(imageSrc !== null){
      setResp(imageSrc)
      setLoading(false)
      setShowModal(true)
    } else {
      setLoading(false)
      setMessageToast({type: "error",msg:"Something went wrong, unable to view file"});
    }
  };

  return (
    <>
      {loading && <LoadingSpinner/>}
      {showModal && ( 
        <Modal
        show={true}
        imgSrc={resp}
        setShowModal={setShowModal}
        isPdf={isPdf}
        loadingStatus={resp}
        isOtherFile = {isOtherFile}
        downloadUrl={resp}
        isSpreadSheet={isSpreadSheet}

        />
      )}
      {messageToast?.msg && <Toast message={messageToast?.msg} type={messageToast?.type} />}
     
     <Label image={true} htmlFor="upload" label={label} tooltip={tooltip} validators={validators} digilocker={digilocker}/>
      <div className={size }>
       

     <>
      { eval(digilocker) ? (
        <Digilocker
                name = {name}
                autofill={autofill}
              />
            ) : (
            <>
              
              { !isUploading && !selectedData?.[name] ? (
                <>
                  <div
                    className={`${isDisabLed ? true:!isEditable && "radioDisabled"} ${
                      !error ? "file-uploader" : "file-uploader error"
                    } px-3 px-md-0 pe-none`}
                  >
                    <Image className="ms-2" imageSrc={ImageUpload} alt="" />
                    { (isEditable || isUserInitiated || eval(isDisabLed)) && !isOtherFile? (
                    <div  {...getRootProps({ className:"dropzone" })}>
                      <input {...getInputProps({ className:"dropzone" })} />
                      <p > Drag and drop or <span className="pe-auto">browse</span> from system upto {maxSizeInMb}MB| {getEnum()?.join(", ")}
                      </p>
                    </div>
                    ) : (isEditable || isUserInitiated || eval(isDisabLed)) && isOtherFile? (
                      <div  {...getRootProps({ className:"dropzone" })}>
                        <input {...getInputProps({ className:"dropzone" })} />
                        <p > Drag and drop or <span className="pe-auto">browse</span> from system {maxSizeInMb}MB| Any
                        </p>
                      </div>
                    ) :(
                    <div className="dropzone" {...getRootProps({ onClick: e => e.stopPropagation() } )}>
                      <p> Drag and drop or <span className="pe-auto">browse</span> from system {maxSizeInMb}MB|{" "}
                          {getEnum()?.join(",")}
                      </p>
                    </div> 
                    )
                    }
                  </div>     
                  {eval(capture) && isEditable ? (
                    <Capture
                        className={`${!isEditable && "radioDisabled"} ${!error ? "file-uploader" : "file-uploader error"
                          }`}
                        setSelectedData={setSelectedData}
                        userInfo={userInfo}
                        clearFieldError={clearFieldError}
                        label={label}
                        isEditable={isEditable}
                        uploaded={uploaded}
                        setUploaded={setUploaded}
                        name={name}
                        setFileName={setFileName}
                        setFileSize={setFileSize}
                        docType={docType}
                        getRootProps={getRootProps}
                        getInputProps={getInputProps}
                        handleOnDropAccepted={handleOnDropAccepted}
                    />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <div className= ".file-uploaded container-fluid border border-2 rounded-2">
                  <ProgressBar
                    fileName={selectedData[name]?.original_name || fileName}
                    fileSize={selectedData[name]?.file_size || fileSize }
                    uploaded={uploaded}
                    cancelClick={cancelClick}
                    removeFiles={removeFiles}
                    error={invalidError}
                    isEditable={isEditable}
                    is_disabled={is_disabled}
                    selectedData={selectedData}
                    autofill={copiedData?.[name] !== undefined}
                    remove_disabled={orcMessage ? true : false}
                    isDisabLed={isDisabLed}
                    previewImage={previewImage}
                  />
                </div>
              )}
           </>
            )}
       </>
        
          
      </div>
     
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};

export default Upload;
